// note: check if we can generalize these components, so they can be used for other forms as well
import { AxiosResponse } from 'axios';
import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Colors } from 'src/styles';
import styled, { css } from 'styled-components';

export const Warning = styled.p`
  color: ${Colors.warning};
`;

export const Spacer = styled.div<{ vertical?: boolean }>`
  ${({ vertical }) =>
    vertical
      ? css`
          width: 0.1rem;
          height: 100%;
          margin-left: 0.75rem;
          margin-right: 0.75rem;
        `
      : css`
          width: 100%;
          height: 0.1rem;
          margin-top: 0.75rem;
          margin-bottom: 0.75rem;
        `}
`;

export const SuccessHandler: FC<{
  response: AxiosResponse | null | undefined;
  to: string;
}> = ({ response, to }) => {
  const [lastResponse] = useState(response);
  const { push } = useHistory();

  useEffect(() => {
    if (response !== lastResponse) {
      push(to);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastResponse, response]);

  return null;
};
